<script setup>
import {onMounted, onUnmounted, ref} from "vue";

const emit = defineEmits(['open'])

const open = ref(false)
const rootEl = ref(null)

const close = () => {
    open.value = false
}

const toggle = () => {
    open.value = !open.value
    if (open.value) emit('open')
}

// A plain click-outside listener (rather than reusing Dropdown.vue, which closes on any click
// inside its content slot) - both the emoji and GIF pickers need clicks/typing inside their
// content (search input, repeated picks) to NOT dismiss the popover.
const onDocClick = (event) => {
    if (open.value && rootEl.value && !rootEl.value.contains(event.target)) close()
}
const onEscape = (event) => {
    if (open.value && event.key === 'Escape') close()
}

onMounted(() => {
    document.addEventListener('click', onDocClick, true)
    document.addEventListener('keydown', onEscape)
})
onUnmounted(() => {
    document.removeEventListener('click', onDocClick, true)
    document.removeEventListener('keydown', onEscape)
})

defineExpose({close})
</script>

<template>
    <div ref="rootEl" class="relative">
        <button type="button" @click="toggle" class="flex items-center justify-center shrink-0 opacity-70 hover:opacity-100 transition-opacity">
            <slot name="trigger" :open="open"/>
        </button>
        <div v-if="open"
             class="absolute bottom-full left-0 mb-2 z-50 rounded-lg shadow-lg ring-1 ring-black/5 dark:ring-slate-200/10 bg-white dark:bg-dark-blue overflow-hidden max-w-[calc(100vw-2rem)]">
            <slot :close="close"/>
        </div>
    </div>
</template>
